import React from "react";
import PlanTracker from "./components/PlanTracker";

/**
 * Componente raíz de la aplicación.
 * Renderiza el plan de entrenamiento 10K.
 */
export default function App() {
  return (
    <div style={{ minHeight: "100vh", background: "var(--bg-secondary, #F3F4F6)" }}>
      <PlanTracker />
    </div>
  );
}
